<template>
    <div>
        <div class="profile-style mb-5 pb-5">
            <h5 class="mb-4">Page Setting</h5>

            <ValidationObserver ref="form">
                <div v-for="data in page_setting" :class="[{ 'active' : active_page === data.id}]" class="mb-3 drag-gallery position-relative" :key="data.id" >
                    
                    <div v-if="detail_event.type === 'STANDARD' && data.name === 'Story' ||
                    detail_event.type === 'STANDARD' && data.name === 'Live Stream Link' ||
                    detail_event.type === 'STANDARD' && data.name === 'Digital Gift' ||
                    detail_event.type === 'STANDARD' && data.name === 'Navigasi' ||
                    detail_event.type === 'STANDARD' && data.name === 'Notification & Rsvn'
                    "
                        class="disabled-feature bdr-15"
                        @click.prevent="$emit('alertPackage')">
                        <i class="uil uil-lock-alt"></i>
                    </div>
                    
                    <div class="link" @click="openPages(data.id)"  :class="[{ 'active' : active_page === data.id}]">
                        <div class="link-body">
                            <div class="link-content">
                                <div class="link-item pr-5">
                                    <div><strong>{{data.name}}</strong></div>
                                </div>
                                <div class="link-switch d-flex" v-on:click.stop="">
                                    <a href="#" v-on:click.prevent="openPages(data.id)" class="act m-0">
                                        <i :class="[active_page === data.id ? 'uil uil-angle-up' : 'uil uil-angle-down']"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                
                    </div>
                    <div class="gallery-wrapper" v-on:click.stop="">
                        
                        <template v-if="active_page === '0'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_opening" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Opening Is Active</strong></span>
                                    <p class="desc">This function is used to display opening on invitation</p>
                                </label>
                            </div>
                            
                            <div class="form-group">
                                <label>Opening Style</label>
                                <div class="row-slide"> 
                                    <div v-for="(data,index) in opening_style" :key="index"
                                        @click="detail_event.opening_style = data.code"
                                        :class="detail_event.opening_style === data.code ? 'active' : ''"
                                        class="style position-relative">
                                            <div class="icon-active"><i class="uil uil-check"></i></div>
                                            <img class="bdr-15" :src="require('@/assets/img/component/opening/' + data.cover)" width="100%">
                                    </div>
                                </div>
                            </div>

                            <div class="row">

                                <div class="mb-1 col-md-12">
                                    <div class="form-group mb-0">
                                        <label>Opening Background Image</label>
                                    </div>
                                </div>

                                <div class="col-4">
                                    <validation-provider v-if="popUpBgRequired && !detail_event.opening_bg_image" rules="required|mimes:image/jpeg,image/png,image/jpg,image/webp" v-slot="{ errors, validate }">
                                        <div class="form-group">
                                            <div class="btn-up d-flex align-items-center" @click="clickUploadImage('opening_bg_image')">
                                                <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                            </div>
                                            <input ref="opening_bg_image" 
                                                    type="file"
                                                    class="custom-file-input d-none"
                                                    id="Thumbnail"
                                                    v-on:change="onImageUpload($event,'opening_bg_image')"
                                                    accept="image/jpeg,image/png,image/jpg,image/webp" 
                                                    @input="validate" >
                        
                                            <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>

                                    <div class="form-group mt-3" v-if="popUpBgRequired && detail_event.opening_bg_image">   
                                        <button v-on:click.prevent="removeImageUpload('opening_bg_image')" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                                        <div class="input-group img-sh">
                                            <img :src="detail_event.opening_bg_image" class="img-responsive img-prf">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <validation-provider v-if="popUpBgRequired && !detail_event.opening_bg_image2" rules="mimes:image/jpeg,image/png,image/jpg,image/webp" v-slot="{ errors, validate }">
                                        <div class="form-group mb-0">
                                            <div class="btn-up d-flex align-items-center" @click="clickUploadImage('opening_bg_image2')">
                                                <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                            </div>
                                            <input ref="opening_bg_image2" 
                                                    type="file"
                                                    class="custom-file-input d-none"
                                                    id="Thumbnail"
                                                    v-on:change="onImageUpload($event,'opening_bg_image2')"
                                                    accept="image/jpeg,image/png,image/jpg,image/webp" 
                                                    @input="validate" >
                        
                                            <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>

                                    <div class="form-group mt-3" v-if="popUpBgRequired && detail_event.opening_bg_image2">   
                                        <button v-on:click.prevent="removeImageUpload('opening_bg_image2')" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                                        <div class="input-group img-sh">
                                            <img :src="detail_event.opening_bg_image2" class="img-responsive img-prf">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <validation-provider v-if="popUpBgRequired && !detail_event.opening_bg_image3" rules="mimes:image/jpeg,image/png,image/jpg,image/webp" v-slot="{ errors, validate }">
                                        <div class="form-group mb-0">
                                            <div class="btn-up d-flex align-items-center" @click="clickUploadImage('opening_bg_image3')">
                                                <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                            </div>
                                            <input ref="opening_bg_image3" 
                                                    type="file"
                                                    class="custom-file-input d-none"
                                                    id="Thumbnail"
                                                    v-on:change="onImageUpload($event,'opening_bg_image3')"
                                                    accept="image/jpeg,image/png,image/jpg,image/webp" 
                                                    @input="validate" >
                        
                                            <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>

                                    <div class="form-group mt-3" v-if="popUpBgRequired && detail_event.opening_bg_image3">   
                                        <button v-on:click.prevent="removeImageUpload('opening_bg_image3')" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                                        <div class="input-group img-sh">
                                            <img :src="detail_event.opening_bg_image3" class="img-responsive img-prf">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <validation-provider v-if="!detail_event.opening_cv_image" rules="mimes:image/jpeg,image/png,image/jpg,image/webp" v-slot="{ errors, validate }">
                                <div class="form-group mt-3">
                                    <div class="mb-1">
                                        <label>Opening Cover Image</label>
                                    </div>
                                    <div class="btn-up d-flex align-items-center" @click="clickUploadImage('opening_cv_image')">
                                        <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                    </div>
                                    <input ref="opening_cv_image" 
                                            type="file"
                                            class="custom-file-input d-none"
                                            id="Thumbnail"
                                            v-on:change="onImageUpload($event,'opening_cv_image')"
                                            accept="image/jpeg,image/png,image/jpg,image/webp" 
                                            @input="validate" >
                
                                    <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                            
                            <div class="form-group mt-3" v-if="detail_event.opening_cv_image">   
                                <div class="mb-1">
                                    <label>Opening Cover Image</label>
                                </div> 
                                <button v-on:click.prevent="removeImageUpload('opening_cv_image')" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                                <div class="input-group img-sh">
                                    <img :src="detail_event.opening_cv_image" class="w-50 img-responsive img-prf">
                                </div>
                            </div>

                            <div class="form-group">
                                <label>Opening Title Top</label>
                                <input v-model="detail_event.opening_title_top" type="text" class="form-control" name="categories">
                            </div>

                            <div class="form-group">
                                <label>Opening Title</label>
                                <input v-model="detail_event.opening_title" type="text" class="form-control" name="categories">
                            </div>

                            <div class="form-group">
                                <label>Opening Title Bottom</label>
                                <input v-model="detail_event.opening_title_bottom" type="text" class="form-control" name="categories">
                            </div>

                            <div class="form-group">
                                <label>Opening Description Top</label>
                                <textarea v-model="detail_event.opening_desc_top" class="form-control"></textarea>
                            </div>

                            <div class="form-group">
                                <label>Opening Description Top When Using Guest Name</label>
                                <textarea v-model="detail_event.opening_desc_top_nm" class="form-control"></textarea>
                            </div>

                            <div class="form-group">
                                <label>Opening Description Botttom</label>
                                <textarea v-model="detail_event.opening_desc_bottom" class="form-control"></textarea>
                            </div>

                            <div class="text-right">
                                <button v-on:click="validationForm('opening')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </template>

                        <template v-if="active_page === '1'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_cover" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Cover Is Active</strong></span>
                                    <p class="desc">This function is used to display cover on invitation</p>
                                </label>
                            </div>

                            <div class="form-group">
                                <label>Cover Style</label>
                                <div class="row-slide"> 
                                    <div v-for="(data,index) in cover_style" :key="index"
                                        @click="detail_event.cover_style = data.code"
                                        :class="detail_event.cover_style === data.code ? 'active' : ''"
                                        class="style position-relative">
                                            <div class="icon-active"><i class="uil uil-check"></i></div>
                                            <img class="bdr-15" :src="require('@/assets/img/component/cover/' + data.cover)" width="100%">
                                    </div>
                                    <div class="style"></div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label>Cover Position</label>
                                <div class="row-style">
                                    <div v-for="(data,index) in cover_position" :key="index"
                                        @click="detail_event.cover_position = data.code"
                                        :class="detail_event.cover_position === data.code ? 'active' : ''"
                                        class="style"><div class="style-item style-img">
                                            <div class="style-tx"><span><i :class="data.cover"></i> {{data.name}}</span></div></div>
                                    </div>
                                    <div class="style"></div>
                                    <div class="style"></div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="mb-1">
                                        <label>Cover Background Image</label>
                                    </div>
                                </div>
                                <div class="col-4">

                                    <validation-provider v-if="!detail_event.cover_bg_image" rules="mimes:image/jpeg,image/png,image/jpg,image/webp" v-slot="{ errors, validate }">
                                        <div class="form-group">
                                            <div class="btn-up d-flex align-items-center" @click="clickUploadImage('cover_bg_image')">
                                                <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                            </div>
                                            <input ref="cover_bg_image" 
                                                    type="file"
                                                    class="custom-file-input d-none"
                                                    id="Thumbnail"
                                                    v-on:change="onImageUpload($event,'cover_bg_image')"
                                                    accept="image/jpeg,image/png,image/jpg,image/webp" 
                                                    @input="validate" >
                        
                                            <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>
                                    
                                    <div class="form-group mt-3" v-if="detail_event.cover_bg_image">   
                                        <button v-on:click.prevent="removeImageUpload('cover_bg_image')" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                                        <div class="input-group img-sh">
                                            <img :src="detail_event.cover_bg_image" class="img-responsive img-prf">
                                        </div>
                                    </div>

                                </div>
                                <div class="col-4">

                                    <validation-provider v-if="!detail_event.cover_bg_image2" rules="mimes:image/jpeg,image/png,image/jpg,image/webp" v-slot="{ errors, validate }">
                                        <div class="form-group">
                                            <div class="btn-up d-flex align-items-center" @click="clickUploadImage('cover_bg_image2')">
                                                <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                            </div>
                                            <input ref="cover_bg_image2" 
                                                    type="file"
                                                    class="custom-file-input d-none"
                                                    id="Thumbnail"
                                                    v-on:change="onImageUpload($event,'cover_bg_image2')"
                                                    accept="image/jpeg,image/png,image/jpg,image/webp" 
                                                    @input="validate" >
                        
                                            <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>
                                    
                                    <div class="form-group mt-3" v-if="detail_event.cover_bg_image2">   
                                        <button v-on:click.prevent="removeImageUpload('cover_bg_image2')" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                                        <div class="input-group img-sh">
                                            <img :src="detail_event.cover_bg_image2" class="img-responsive img-prf">
                                        </div>
                                    </div>

                                </div>
                                <div class="col-4">
                                    <validation-provider v-if="!detail_event.cover_bg_image3" rules="mimes:image/jpeg,image/png,image/jpg,image/webp" v-slot="{ errors, validate }">
                                        <div class="form-group">
                                            <div class="btn-up d-flex align-items-center" @click="clickUploadImage('cover_bg_image3')">
                                                <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                            </div>
                                            <input ref="cover_bg_image3" 
                                                    type="file"
                                                    class="custom-file-input d-none"
                                                    id="Thumbnail"
                                                    v-on:change="onImageUpload($event,'cover_bg_image3')"
                                                    accept="image/jpeg,image/png,image/jpg,image/webp" 
                                                    @input="validate" >
                        
                                            <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>
                                    
                                    <div class="form-group mt-3" v-if="detail_event.cover_bg_image3">   
                                        <button v-on:click.prevent="removeImageUpload('cover_bg_image3')" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                                        <div class="input-group img-sh">
                                            <img :src="detail_event.cover_bg_image3" class="img-responsive img-prf">
                                        </div>
                                    </div>
                                </div>
                            </div>
                         

                            <div class="form-group">
                                <label>Cover Title Top</label>
                                <input v-model="detail_event.cover_title_top" type="text" class="form-control" name="categories">
                            </div>

                            <div class="form-group">
                                <label>Cover Title</label>
                                <input v-model="detail_event.cover_title" type="text" class="form-control" name="categories">
                            </div>

                            <div class="form-group">
                                <label>Cover Title Bottom</label>
                                <input v-model="detail_event.cover_title_bottom" type="text" class="form-control" name="categories">
                            </div>

                            <div class="text-right">
                                <button v-on:click="validationForm('cover')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </template>

                        <form v-show="active_page === '2'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_person" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Person Is Active</strong></span>
                                    <p class="desc">This function is used to display person on invitation</p>
                                </label>
                            </div>
                            
                            <div class="form-group">
                                <label>Person Style</label>
                                <div class="row-slide"> 
                                    <div v-for="(data,index) in person_style" :key="index"
                                        @click="detail_event.person_style = data.code"
                                        :class="detail_event.person_style === data.code ? 'active' : ''"
                                        class="style position-relative">
                                            <div class="icon-active"><i class="uil uil-check"></i></div>
                                            <img class="bdr-15" :src="require('@/assets/img/component/person/' + data.cover)" width="100%">
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label>Person Title</label>
                                <input v-model="detail_event.person_title" type="text" class="form-control" name="categories">
                            </div>

                            <div class="form-group">
                                <label>Description Person Top</label>
                                <ckeditor :editor="editor" v-if="!isSourceEditing" v-model="detail_event.content_person" :config="editorConfig"></ckeditor>
                                <textarea v-model="detail_event.content_person" style="height: 230px;" class="form-control" v-if="isSourceEditing"></textarea>
                                <button type="button" class="btn btn-outline-dark mt-1" @click.prevent="toggleSourceEditing">{{!isSourceEditing ? 'Code Editing' : 'Editor Editing'}}</button>
                            </div>
                            
                            <div class="form-group">
                                <label>Description Person Bottom</label>
                                <ckeditor :editor="editor" v-if="!isSourceEditing" v-model="detail_event.content_person_closing" :config="editorConfig"></ckeditor>
                                <textarea v-model="detail_event.content_person_closing" style="height: 230px;" class="form-control" v-if="isSourceEditing"></textarea>
                                <button type="button" class="btn btn-outline-dark mt-1" @click.prevent="toggleSourceEditing">{{!isSourceEditing ? 'Code Editing' : 'Editor Editing'}}</button>
                            </div>
                            
                            <div class="text-right">
                                <button v-on:click="validationForm('person')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </form>

                        <template v-if="active_page === '2.1'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_story" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Story Is Active</strong></span>
                                    <p class="desc">This function is used to display story on invitation</p>
                                </label>
                            </div>

                            <div class="form-group">
                                <label>Story Title</label>
                                <input v-model="detail_event.story_title" type="text" class="form-control" name="categories">
                            </div>

                            <div class="text-right">
                                <button v-on:click="validationForm('story')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </template>

                        <form v-show="active_page === '3'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_schedule" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Schedule Is Active</strong></span>
                                    <p class="desc">This function is used to display schedule on invitation</p>
                                </label>
                            </div>

                            <div class="form-group">
                                <label>Schedule Style</label>
                                <div class="row-slide"> 
                                    <div v-for="(data,index) in schedule_style" :key="index"
                                        @click="detail_event.schedule_style = data.code"
                                        :class="detail_event.schedule_style === data.code ? 'active' : ''"
                                        class="style position-relative">
                                            <div class="icon-active"><i class="uil uil-check"></i></div>
                                            <img class="bdr-15" :src="require('@/assets/img/component/schedule/' + data.cover)" width="100%">
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label>Schedule Title</label>
                                <input v-model="detail_event.schedule_title" type="text" class="form-control" name="categories">
                            </div>

                            <div class="form-group">
                                <label>Description Schedule Top</label>
                            
                                <ckeditor :editor="editor" v-if="!isSourceEditing" v-model="detail_event.schedule_content" :config="editorConfig"></ckeditor>
                                <textarea v-model="detail_event.schedule_content" style="height: 230px;" class="form-control" v-if="isSourceEditing"></textarea>
                                <button type="button" class="btn btn-outline-dark mt-1" @click.prevent="toggleSourceEditing">{{!isSourceEditing ? 'Code Editing' : 'Editor Editing'}}</button>
                                
                            </div>
                            
                            <div class="form-group">
                                <label>Description Schedule Bottom</label>
                               
                                <ckeditor :editor="editor" v-if="!isSourceEditing" v-model="detail_event.schedule_content_closing" :config="editorConfig"></ckeditor>
                                <textarea v-model="detail_event.schedule_content_closing" style="height: 230px;" class="form-control" v-if="isSourceEditing"></textarea>
                                <button type="button" class="btn btn-outline-dark mt-1" @click.prevent="toggleSourceEditing">{{!isSourceEditing ? 'Code Editing' : 'Editor Editing'}}</button>
                            </div>
                           
                            <div class="text-right">
                                <button v-on:click="validationForm('schedule')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </form>

                        <form v-show="active_page === '3.1'">
                            <div class="d-flex position-relative">
                            
                                <label class="pl-0 custom-switch switch-big" :class="detail_event.type === 'STANDARD' ? 'pl-4' : ''">
                                    <input v-model="detail_event.is_gcalendar" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Google Calendar Is Active</strong></span>
                                    <p class="desc">This function is used to display google calendar on pages</p>
                                </label>
                            </div>
                            
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_rsv" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Rsvp Is Active</strong></span>
                                    <p class="desc">This function is used to display reservation guest on pages</p>
                                </label>
                            </div>

                            <div class="form-group">
                                <label>Rsvp Title</label>
                                <input v-model="detail_event.rsv_title" type="text" class="form-control" name="categories">
                            </div>

                            <div class="form-group">
                                <label>Description Rsvp</label>
                               
                                <ckeditor :editor="editor" v-if="!isSourceEditing" v-model="detail_event.rsv_content" :config="editorConfig"></ckeditor>
                                <textarea v-model="detail_event.rsv_content" style="height: 230px;" class="form-control" v-if="isSourceEditing"></textarea>
                                <button type="button" class="btn btn-outline-dark mt-1" @click.prevent="toggleSourceEditing">{{!isSourceEditing ? 'Code Editing' : 'Editor Editing'}}</button>
                            </div>
                            
                            <div class="text-right">
                                <button v-on:click="validationForm('rsv')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </form>

                        <form v-show="active_page === '4'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_live" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Live Link Is Active</strong></span>
                                    <p class="desc">This function is used to display link to watch event live</p>
                                </label>
                            </div>

                            <div class="form-group">
                                <label>Live Title</label>
                                <input v-model="detail_event.live_title" type="text" class="form-control" name="categories">
                            </div>

                            <div class="form-group">
                                <label>Description Live Link</label>
                               
                                <ckeditor :editor="editor" v-if="!isSourceEditing" v-model="detail_event.live_content" :config="editorConfig"></ckeditor>
                                <textarea v-model="detail_event.live_content" style="height: 230px;" class="form-control" v-if="isSourceEditing"></textarea>
                                <button type="button" class="btn btn-outline-dark mt-1" @click.prevent="toggleSourceEditing">{{!isSourceEditing ? 'Code Editing' : 'Editor Editing'}}</button>
                            </div>

                            <validation-provider rules="multi_url" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Youtube, Zoom, and Google Meet Url</label>
                                    <textarea v-model="detail_event.live_link" class="form-control"></textarea>
                                    <small>Separate urls with commas(,) if you want to load more than one link</small>
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>

                            <div class="text-right">
                                <button v-on:click="validationForm('live')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </form>

                        <template v-if="active_page === '5'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_countdown" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Countdown Time Is Active</strong></span>
                                    <p class="desc">This function is used to display countdown time on invitation</p>
                                </label>
                            </div>

                            <div class="form-group">
                                <label>Countdown Time Title</label>
                                <input v-model="detail_event.countdown_title" type="text" class="form-control" name="categories">
                            </div>

                            <div class="text-right">
                                <button v-on:click="validationForm('countdown')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </template>

                        <template v-if="active_page === '6'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_location" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Location Is Active</strong></span>
                                    <p class="desc">This function is used to display location on invitation</p>
                                </label>
                            </div>

                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Location Title</label>
                                    <input v-model="detail_event.location_title" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>

                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Event Location</label>
                                    <input v-model="detail_event.location" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                           
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Google Maps Link</label>
                                    <input v-model="detail_event.google_maps_link" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                            
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Google Maps Frame</label>
                                    <input v-model="detail_event.google_maps" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>

                            <div class="text-right">
                                <button v-on:click="validationForm('location')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </template>

                        <template v-if="active_page === '7'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_video" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Video Is Active</strong></span>
                                    <p class="desc">This function is used to video cover on invitation</p>
                                </label>
                            </div>

                            <div class="form-group">
                                <label>Video Title</label>
                                <input v-model="detail_event.video_title" type="text" class="form-control" name="categories">
                            </div>

                            <validation-provider :rules="detail_event.type === 'STANDARD' ? 'url' : 'multi_url'" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Youtube Video Or Google Drive Url (Recommended Youtube)</label>
                                    <textarea :placeholder="detail_event.type === 'PREMIUM' ? 'https://www.youtube.com/watch?v=sDuW1xvmZqw, https://www.youtube.com/watch?v=sDuW1xvmZqw' : 'https://www.youtube.com/watch?v=sDuW1xvmZqw'"
                                              v-model="detail_event.video"
                                              class="form-control">
                                    </textarea>
                                    <small v-if="detail_event.type === 'PREMIUM'" >Separate urls with commas(,) if you want to load more than one video</small>
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>

                            <div class="text-right">
                                <button v-on:click="validationForm('video')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </template>

                        <template v-if="active_page === '8'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_gallery" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Gallery Is Active</strong></span>
                                    <p class="desc">This function is used to display gallery on pages</p>
                                </label>
                            </div>
                                                        
                            <div class="form-group">
                                <label>Gallery Style</label>
                                <div class="row-slide"> 
                                    <div v-for="(data,index) in gallery_style" :key="index"
                                        @click="detail_event.gallery_style = data.code"
                                        :class="detail_event.gallery_style === data.code ? 'active' : ''"
                                        class="style position-relative">
                                            <div class="icon-active"><i class="uil uil-check"></i></div>
                                            <img class="bdr-15" :src="require('@/assets/img/component/gallery/' + data.cover)" width="100%">
                                    </div>
                                </div>
                            </div>
                            
                            <div class="form-group">
                                <label>Gallery Title</label>
                                <input v-model="detail_event.gallery_title" type="text" class="form-control" name="categories">
                            </div>

                            <div class="form-group">
                                <label>Gallery Description</label>
                              
                                <ckeditor :editor="editor" v-if="!isSourceEditing" v-model="detail_event.gallery_content" :config="editorConfig"></ckeditor>
                                <textarea v-model="detail_event.gallery_content" style="height: 230px;" class="form-control" v-if="isSourceEditing"></textarea>
                                <button type="button" class="btn btn-outline-dark mt-1" @click.prevent="toggleSourceEditing">{{!isSourceEditing ? 'Code Editing' : 'Editor Editing'}}</button>
                            </div>

                            <div class="d-flex position-relative" :class="detail_event.type === 'STANDARD' ? 'mb-4' : ''">
                                <div v-if="detail_event.type === 'STANDARD'" class="disabled-feature bdr-15" @click.prevent="$emit('alertPackage')">
                                    <i class="uil uil-lock-alt"></i>
                                </div>
                                <label class="pl-0 custom-switch switch-big" :class="detail_event.type === 'STANDARD' ? 'pl-4' : ''">
                                    <input v-model="detail_event.is_album" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Album Is Active</strong></span>
                                    <p class="desc">This function is used to display gallery on pages album</p>
                                </label>
                            </div>

                            <template v-if="detail_event.is_album === 'true'">
                                <div class="form-group">
                                    <label>Number of photos on the invitation page</label>
                                    <input v-model="detail_event.gallery_show" type="number" class="form-control" name="categories">
                                </div>

                                <validation-provider v-if="!detail_event.album_opening_bg_image" rules="required|mimes:image/jpeg,image/png,image/jpg,image/webp" v-slot="{ errors, validate }">
                                    <div class="form-group mt-3">
                                        <div class="mb-1">
                                            <label>Opening Album Background Image</label>
                                        </div>
                                        <div class="btn-up d-flex align-items-center" @click="clickUploadImage('album_opening_bg_image')">
                                            <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                        </div>
                                        <input ref="album_opening_bg_image" 
                                                type="file"
                                                class="custom-file-input d-none"
                                                id="Thumbnail"
                                                v-on:change="onImageUpload($event,'album_opening_bg_image')"
                                                accept="image/jpeg,image/png,image/jpg,image/webp" 
                                                @input="validate" >
                    
                                        <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                    </div>
                                </validation-provider>
                                
                                <div class="form-group mt-3" v-if="detail_event.album_opening_bg_image">   
                                    <div class="mb-1">
                                        <label>Opening Album Background Image</label>
                                    </div> 
                                    <button v-on:click.prevent="removeImageUpload('album_opening_bg_image')" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                                    <div class="input-group img-sh">
                                        <img :src="detail_event.album_opening_bg_image" class="w-50 img-responsive img-prf">
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>Album Cover Title Top</label>
                                    <input v-model="detail_event.album_title" type="text" class="form-control" name="categories">
                                </div>

                                <div class="form-group">
                                    <label>Album Cover Title Bottom</label>
                                    <input v-model="detail_event.album_title_bottom" type="text" class="form-control" name="categories">
                                </div>

                                <div class="form-group">
                                    <label>Album Opening Title</label>
                                    <input v-model="detail_event.album_op_title" type="text" class="form-control" name="categories">
                                </div>

                                <div class="form-group">
                                    <label>Album Opening Description</label>
                                 
                                    <ckeditor :editor="editor" v-if="!isSourceEditing" v-model="detail_event.album_op_desc" :config="editorConfig"></ckeditor>
                                    <textarea v-model="detail_event.album_op_desc" style="height: 230px;" class="form-control" v-if="isSourceEditing"></textarea>
                                    <button type="button" class="btn btn-outline-dark mt-1" @click.prevent="toggleSourceEditing">{{!isSourceEditing ? 'Code Editing' : 'Editor Editing'}}</button>
                                </div>

                            </template>

                            <div class="text-right">
                                <button v-on:click="validationForm('gallery')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </template>

                        <form v-show="active_page === '9'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_quto" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Quto Is Active</strong></span>
                                    <p class="desc">This function is used to display quto on pages</p>
                                </label>
                            </div>

                            <div class="form-group">
                                <label>Description Quto</label>
                                
                                <ckeditor :editor="editor" v-if="!isSourceEditing" v-model="detail_event.quto_content" :config="editorConfig"></ckeditor>
                                <textarea v-model="detail_event.quto_content" style="height: 230px;" class="form-control" v-if="isSourceEditing"></textarea>
                                <button type="button" class="btn btn-outline-dark mt-1" @click.prevent="toggleSourceEditing">{{!isSourceEditing ? 'Code Editing' : 'Editor Editing'}}</button>
                            </div>
                            
                            <div class="text-right">
                                <button v-on:click="validationForm('quto')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </form>
                       
                        <template v-if="active_page === '10'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_comment" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Guestbook Is Active</strong></span>
                                    <p class="desc">This function is used to display comment on pages</p>
                                </label>
                            </div>

                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_comment_sts" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Show Status Guest in Guestbook</strong></span>
                                    <p class="desc">This function is used to display status on in Guestbook form</p>
                                </label>
                            </div>

                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Guestbook Title</label>
                                    <input v-model="detail_event.comment_title" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>


                            <label>Guestbook Message Detail</label>
                            <div class="border p-3 mb-4">
                                <p>Use this funtion if you want to delete message in guestbook event</p>
                                <button class="btn btn-warning" v-b-modal.modal-Message>Message</button>
                            </div>

                            <div class="text-right">
                                <button v-on:click="validationForm('comment')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </template>

                        <form v-show="active_page === '11'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_gift_comment" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Digital Gift On Page</strong></span>
                                    <p class="desc">This function is used to display digital gift on pages</p>
                                </label>
                            </div>
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_gift" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Digital Gift Popup</strong></span>
                                    <p class="desc">This function is used to display digital gift on popup</p>
                                </label>
                            </div>

                            <div class="form-group">
                                <label>Digital Gift Title</label>
                                <input v-model="detail_event.gift_title" type="text" class="form-control" name="categories">
                            </div>

                            <div class="form-group">
                                <label>Description Digital Gift</label>
                               
                                <ckeditor :editor="editor" v-if="!isSourceEditing" v-model="detail_event.gift_content" :config="editorConfig"></ckeditor>
                                <textarea v-model="detail_event.gift_content" style="height: 230px;" class="form-control" v-if="isSourceEditing"></textarea>
                                <button type="button" class="btn btn-outline-dark mt-1" @click.prevent="toggleSourceEditing">{{!isSourceEditing ? 'Code Editing' : 'Editor Editing'}}</button>
                            </div>

                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_confirm_gift" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Confirm Digital Gift Is Active</strong></span>
                                    <p class="desc">This function is used to display confirmation form digital gift on pages</p>
                                </label>
                            </div>

                            <div class="form-group">
                                <label>Digital Gift Confirmation Title</label>
                                <input v-model="detail_event.confirm_gift_title" type="text" class="form-control" name="categories">
                            </div>

                            <div class="form-group">
                                <label>Description Digital Gift Confirmation</label>
                              
                                <ckeditor :editor="editor" v-if="!isSourceEditing" v-model="detail_event.gift_confirm_content" :config="editorConfig"></ckeditor>
                                <textarea v-model="detail_event.gift_confirm_content" style="height: 230px;" class="form-control" v-if="isSourceEditing"></textarea>
                                <button type="button" class="btn btn-outline-dark mt-1" @click.prevent="toggleSourceEditing">{{!isSourceEditing ? 'Code Editing' : 'Editor Editing'}}</button>
                            </div>

                            <div class="text-right">
                                <button v-on:click="validationForm('gift')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </form>

                        <form v-show="active_page === '13'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_info" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Custom Information Is Active</strong></span>
                                    <p class="desc">This function is used to display custom information on pages</p>
                                </label>
                            </div>

                            <div class="form-group">
                                <label>Information Title</label>
                                <input v-model="detail_event.info_title" type="text" class="form-control" name="categories">
                            </div>

                            <div class="form-group">
                                <label>Description</label>
                            
                                <ckeditor :editor="editor" v-if="!isSourceEditing" v-model="detail_event.info_content" :config="editorConfig"></ckeditor>
                                <textarea v-model="detail_event.info_content" style="height: 230px;" class="form-control" v-if="isSourceEditing"></textarea>
                                <button type="button" class="btn btn-outline-dark mt-1" @click.prevent="toggleSourceEditing">{{!isSourceEditing ? 'Code Editing' : 'Editor Editing'}}</button>
                            </div>

                            <div class="text-right">
                                <button v-on:click="validationForm('info')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </form>

                        <template v-if="active_page === '14'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_footer" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Custom Copyright Is Active</strong></span>
                                    <p class="desc">This function is used to display copyright information on pages</p>
                                </label>
                            </div>

                            <div class="form-group mb-2">
                                <label>Copyright Type</label>
                                <div>
                                    <button @click="detail_event.copyright_type = 'C-DEFAULT'" :class="detail_event.copyright_type === 'C-DEFAULT' ? 'active' : ''" class="btn-ii mr-2 mb-2">Default Info</button>
                                    <button @click="detail_event.copyright_type = 'C-PROFILE'" :class="detail_event.copyright_type === 'C-PROFILE' ? 'active' : ''" class="btn-ii mr-2 mb-2">Profile Info</button>
                                    <button v-if="detail_event.partner_id" @click="detail_event.copyright_type = 'C-PARTNER'" :class="detail_event.copyright_type === 'C-PARTNER' ? 'active' : ''" class="btn-ii mr-2 mb-2">Partner Info</button>
                                    <button @click="detail_event.copyright_type = 'C-CUSTOM'" :class="detail_event.copyright_type === 'C-CUSTOM' ? 'active' : ''" class="btn-ii mr-2 mb-2">Custom Info</button>
                                </div>
                            </div>

                            <template v-if="detail_event.copyright_type === 'C-CUSTOM'">
                                <validation-provider v-if="!detail_event.copyright_image" rules="mimes:image/jpeg,image/png,image/jpg,image/webp" v-slot="{ errors, validate }">
                                    <div class="form-group mt-3">
                                        <div class="mb-1">
                                            <label>Copyright Logo</label>
                                        </div>
                                        <div class="btn-up d-flex align-items-center" @click="$refs.inputCopyright[0].click()">
                                            <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                        </div>
                                        <input ref="inputCopyright" 
                                                type="file"
                                                class="custom-file-input d-none"
                                                id="Thumbnail"
                                                v-on:change="onImageCopyrightUpload"
                                                accept="image/jpeg,image/png,image/jpg,image/webp" 
                                                @input="validate" >
                    
                                        <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                    </div>
                                </validation-provider>

                                <div class="form-group mt-3" v-if="detail_event.copyright_image">   
                                    <div class="mb-1">
                                        <label>Copyright Logo</label>
                                    </div> 
                                    <button v-on:click.prevent="removeImageCopyrightUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                                    <div class="input-group img-sh">
                                        <img :src="detail_event.copyright_image" class="w-50 img-responsive img-prf">
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>Copyright Text</label>
                                    <input v-model="detail_event.copyright_text" type="text" class="form-control" name="categories">
                                </div>

                                <validation-provider rules="multi_url" v-slot="{ errors }">
                                    <div class="form-group">
                                        <label>Social Media On Copyright</label>
                                        <textarea v-model="detail_event.copyright_sosmed" class="form-control"></textarea>
                                        <small>Separate urls with commas(,) if you want to load more than one link</small>
                                        <div class="invalid-input">{{ errors[0] }}</div>
                                    </div>
                                </validation-provider>
                            </template>

                            <div class="text-right">
                                <button v-on:click="validationForm('footer')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </template>

                        <template v-if="active_page === '15'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="detail_event.is_menu" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Navigasi Is Active</strong></span>
                                    <p class="desc">This function is used to display navigasi on pages</p>
                                </label>
                            </div>

                            <div class="form-group">
                                <label>Menu Style</label>
                                <div class="row-slide"> 
                                    <div v-for="(data,index) in menu_style_md" :key="index"
                                        @click="detail_event.menu_style = data.code"
                                        :class="detail_event.menu_style === data.code ? 'active' : ''"
                                        class="style position-relative">
                                            <div class="icon-active"><i class="uil uil-check"></i></div>
                                            <img class="bdr-15" :src="require('@/assets/img/component/menu/' + data.cover)" width="100%">
                                    </div>
                                    <div class="style"></div>
                                    <div class="style"></div>
                                </div>
                            </div>

                            <div class="table-responsive">
                                <table class="table">
                                    <tr class="border-bottom">
                                        <th></th>
                                        <th>Icon</th>
                                        <th>Name</th>
                                        <th>Status</th>
                                    </tr>

                                    <draggable
                                        v-bind="NavdragOptions" 
                                        v-model="detail_event.navigation" 
                                        handle=".handle"
                                        @start="drag_nav = true"
                                        @end="drag_nav = false"
                                        :element="'tbody'"
                                    >
                                        <tr v-for="(data,index) in detail_event.navigation" :key="data.id">
                                            <td width="50px">
                                                <i class="handle uil uil-draggabledots"></i>
                                            </td>
                                            <td width="200px">
                                                    <validation-provider v-if="!data.icon" rules="mimes:image/jpeg,image/png,image/jpg,image/webp" v-slot="{ errors, validate }">
                                                    <div class="form-group mt-3 mb-0">
                                                        <div style="height: 50px;" class="btn-up d-flex align-items-center" @click="addNavIcon(index)">
                                                            <div class="upload"><i class="uil uil-image mr-1"></i> ADD ICON</div>
                                                        </div>
                                                        <input  :ref="'inputNavIcon' + index" 
                                                                :id="'inputNavIcon' + index"  
                                                                type="file"
                                                                class="custom-file-input d-none"
                                                                v-on:change="onIconNavUpload($event,index)"
                                                                accept="image/jpeg,image/png,image/jpg,image/webp" 
                                                                @input="validate" >
                                    
                                                        <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                                    </div>
                                                </validation-provider>
                                                
                                                <div class="form-group mt-3 mb-0" v-if="data.icon">   
                                                    <button v-on:click.prevent="removeIconNavUpload(index)" type="button" class="btn-remove-image">Change</button> 
                                                    <div class="input-group img-sh">
                                                        <img :src="data.icon" class="w-50 img-responsive img-prf">
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <input type="text" v-model="data.name" class="form-control">
                                            </td>
                                            <td width="100px">
                                                <label class="pl-0 custom-switch switch-big">
                                                    <input v-model="data.status" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                                    <span class="custom-switch-indicator"></span>
                                                </label>
                                            </td>
                                        </tr>
                                    </draggable>        
                                </table>
                            </div>


                            <div class="text-right">
                                <button v-on:click="validationForm('navigation')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Event
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
            </ValidationObserver>
        </div>

        <b-modal id="modal-Message" size="lg" class="modal-form" title="Event Guestbook Message" centered hide-footer>
            <div class="box" v-if="del_message.length !== 0">
                <button class="btn btn-danger" @click.prevent="alertdeleteMessage()">Delete Selected Message</button>
            </div>
            <div class="table-responsive bdr-15 mt-3 position-relative">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="all_id" v-model="selectAllMessage">
                                    <label class="custom-control-label" for="all_id"></label>
                                </div>
                            </th>
                            <th>Name</th>
                            <th>Message</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="data in detail_event.messages" :key="data.id">
                            <td width="100px" v-on:click.stop=""> 
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" v-model="del_message" :value="data.id" :id="data.id">
                                    <label class="custom-control-label" :for="data.id"></label>
                                </div>
                            </td>
                            <td>{{data.name}}</td>
                            <td>{{data.message}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex'
    import {ValidationProvider, ValidationObserver, extend } from "vee-validate";
    import draggable from 'vuedraggable'

    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

    extend('youtube', {
        message: 'Url Youtube not valid',
        validate: value => /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/.test(value),
    });

    export default{
        data(){
            return{
                editor: ClassicEditor,
                editorData: '<p>Content of the editor.</p>',
                editorConfig: {
                    toolbar: {
                        items: [
                            'heading',
                            'bold',
                            'italic',
                            'link',
                            'undo',
                            'redo',
                            '|',
                            'bulletedList',
                            'numberedList',
                            'insertTable',
                            'sourceEditing',
                            'mediaEmbed',
                        ],
                    }
                },
                isSourceEditing: false,

                loading:false,
                active_page:'',
                drag_nav:false,
                del_message:[],
                page_setting:[
                    {id:'0',name:'Opening'},
                    {id:'1',name:'Cover'},
                    {id:'2',name:'Person'},
                    {id:'2.1',name:'Story'},
                    {id:'3',name:'Schedule'},
                    {id:'3.1',name:'Notification & Rsvn'},
                    {id:'4',name:'Live Stream Link'},
                    {id:'5',name:'Countdown Time'},
                    {id:'6',name:'Location'},
                    {id:'7',name:'Video'},
                    {id:'8',name:'Gallery'},
                    {id:'9',name:'Quto'},
                    {id:'10',name:'Guest Book'},
                    {id:'11',name:'Digital Gift'},
                    {id:'13',name:'Covid Information'},
                    {id:'14',name:'Copyright'},
                    {id:'15',name:'Navigasi'},
                ],

                opening_bg_image:'',
                opening_bg_image2:'',
                opening_bg_image3:'',

                opening_cv_image:'',

                cover_bg_image:'',
                cover_bg_image2:'',
                cover_bg_image3:'',

                album_opening_bg_image:'',

                photo_file:'',
                photo_copyright:'',

            }
        },
        props:{
            detail_event:{
                type: Object,
                required: true,
            },
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            draggable,
        },
        computed: {
            ...mapState('EventsControl', {
                opening_style: state => state.opening_style,
                cover_style: state => state.cover_style,
                cover_position: state => state.cover_position,
                person_style: state => state.person_style,
                schedule_style: state => state.schedule_style,
                gallery_style: state => state.gallery_style,
                menu_style_md: state => state.menu_style_md
            }),
            
            selectAllMessage: {
                get: function () {
                    return this.detail_event.messages ? this.del_message.length == this.detail_event.messages.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.detail_event.messages.forEach(function (m) {
                            if(m.id !== 1){
                                selected.push(m.id);
                            }
                        });
                    }
                    this.del_message = selected;
                }
            },
            NavdragOptions() {
                return {
                    animation: 200,
                    group: "catperson",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            popUpBgRequired: function(){
                var sts = false
                this.opening_style.forEach(data => {
                    if(data.code === this.detail_event.opening_style && data.type == 'I1' || data.code === this.detail_event.opening_style && data.type == 'I2'){
                        sts = true
                    }
                });
                
                return sts
            },
            popUpCvrRequired: function(){
                var sts = false
                this.opening_style.forEach(data => {
                    if(data.code === this.detail_event.opening_style && data.type == 'I2'){
                        sts = true
                    }
                });

                return sts
            },

            coverBgRequired: function(){
                var sts = false
                this.cover_style.forEach(data => {
                    if(data.code === this.detail_event.cover_style && data.type == 'I1'){
                        sts = true
                    }
                });
                
                return sts
            },
        },
        methods:{
            ...mapActions('EventsControl', ['detailEvents','updateBasicSetup','deleteGuesbookMessage']),
            toggleSourceEditing() {
                this.isSourceEditing = !this.isSourceEditing;
            },
            clickUploadImage:function(type){
                this.$refs[type][0].click()
            },
            onImageUpload: function(event,type) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.detail_event[type] = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this[type] = input.files[0]
            },
            removeImageUpload:function(type){
                 this[type] = ''
                 this.detail_event[type] = ''
            },
            
            onImageCopyrightUpload: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.detail_event.copyright_image = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this.photo_copyright = input.files[0]
            },
            removeImageCopyrightUpload:function(){
                this.photo_copyright = ''
                this.detail_event.copyright_image = ''
            },
            openPages: function(id){
                if(id == this.active_page){
                    this.active_page = ''
                }else{
                    this.active_page = id
                }
            },
            
            alertdeleteMessage:function(){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this guestbook message data? This action cannot be undone",
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteGuesbookMessage(this.del_message).then(
                            this.$toast.success('Successfully Deleting Guestbook Message'),
                            this.detailEvents(this.$route.params.id),
                            this.del_message = []
                        ).catch((error) => {
                            console.log(error)
                            this.$toast.warning('Sorry, Something Error')
                        })
                    }
                })
            },
            //NAVIGATION
            addNavIcon:function(index){
                this.$refs['inputNavIcon' + index][0].click()
            },
            onIconNavUpload: function(event,index) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.detail_event.navigation[index].icon = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this.detail_event.navigation[index].icon_file = input.files[0]
            },
            removeIconNavUpload:function(index){
                this.detail_event.navigation[index].icon_file = ''
                this.detail_event.navigation[index].icon = ''
            },


            validationForm: function(type) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var formData = new FormData();
                       
                        if(type == 'opening'){
                        
                            formData.append('is_opening', this.detail_event.is_opening ? this.detail_event.is_opening : '');
                            formData.append('opening_title_top', this.detail_event.opening_title_top ? this.detail_event.opening_title_top : '');
                            formData.append('opening_title', this.detail_event.opening_title ? this.detail_event.opening_title : '');
                            formData.append('opening_title_bottom', this.detail_event.opening_title_bottom ? this.detail_event.opening_title_bottom : '');
                            formData.append('opening_desc_top', this.detail_event.opening_desc_top ? this.detail_event.opening_desc_top : '');
                            formData.append('opening_desc_top_nm', this.detail_event.opening_desc_top_nm ? this.detail_event.opening_desc_top_nm : '');
                            formData.append('opening_desc_bottom', this.detail_event.opening_desc_bottom ? this.detail_event.opening_desc_bottom : '');
                            formData.append('opening_style', this.detail_event.opening_style);

                            formData.append('opening_bg_image_file', this.opening_bg_image);
                            formData.append('opening_bg_image_file2', this.opening_bg_image2);
                            formData.append('opening_bg_image_file3', this.opening_bg_image3);

                            formData.append('opening_bg_image', this.detail_event.opening_bg_image ? this.detail_event.opening_bg_image : '');
                            formData.append('opening_bg_image2', this.detail_event.opening_bg_image2 ? this.detail_event.opening_bg_image2 : '');
                            formData.append('opening_bg_image3', this.detail_event.opening_bg_image3 ? this.detail_event.opening_bg_image3 : '');

                            formData.append('opening_cv_image_file', this.opening_cv_image);
                            formData.append('opening_cv_image', this.detail_event.opening_cv_image ? this.detail_event.opening_cv_image : '');

                        
                        }else if(type == 'cover'){

                            formData.append('is_cover', this.detail_event.is_cover);
                            formData.append('cover_title_top', this.detail_event.cover_title_top ? this.detail_event.cover_title_top : '');
                            formData.append('cover_title', this.detail_event.cover_title ? this.detail_event.cover_title : '');
                            formData.append('cover_title_bottom', this.detail_event.cover_title_bottom ? this.detail_event.cover_title_bottom : '');
                            formData.append('cover_style', this.detail_event.cover_style);
                            formData.append('cover_position', this.detail_event.cover_position);

                            formData.append('cover_bg_image_file', this.cover_bg_image);
                            formData.append('cover_bg_image_file2', this.cover_bg_image2);
                            formData.append('cover_bg_image_file3', this.cover_bg_image3);

                            formData.append('cover_bg_image', this.detail_event.cover_bg_image ? this.detail_event.cover_bg_image : '');
                            formData.append('cover_bg_image2', this.detail_event.cover_bg_image2 ? this.detail_event.cover_bg_image2 : '');
                            formData.append('cover_bg_image3', this.detail_event.cover_bg_image3 ? this.detail_event.cover_bg_image3 : '');

                        }else if(type == 'person'){
                         
                            formData.append('is_person', this.detail_event.is_person);
                            formData.append('person_title', this.detail_event.person_title ? this.detail_event.person_title : '');
                            formData.append('person_style', this.detail_event.person_style);
                            formData.append('content_person', this.detail_event.content_person ? this.detail_event.content_person : '');
                            formData.append('content_person_closing', this.detail_event.content_person_closing ? this.detail_event.content_person_closing : '');
                        
                        }else if(type == 'story'){
                         
                            formData.append('is_story', this.detail_event.is_story);
                            formData.append('story_title', this.detail_event.story_title ? this.detail_event.story_title : '');
                     
                        }else if(type == 'schedule'){
                           
                            formData.append('is_schedule', this.detail_event.is_schedule);
                            formData.append('schedule_title', this.detail_event.schedule_title ? this.detail_event.schedule_title : '');
                            formData.append('schedule_style', this.detail_event.schedule_style);
                            formData.append('schedule_content', this.detail_event.schedule_content ? this.detail_event.schedule_content : '');
                            formData.append('schedule_content_closing', this.detail_event.schedule_content_closing ? this.detail_event.schedule_content_closing : '');
                        
                        }else if(type == 'rsv'){

                            formData.append('is_gcalendar', this.detail_event.is_gcalendar);
                            formData.append('is_notification', this.detail_event.is_notification);
                            formData.append('is_rsv', this.detail_event.is_rsv);
                            formData.append('rsv_title', this.detail_event.rsv_title ? this.detail_event.rsv_title : '');
                            formData.append('rsv_content', this.detail_event.rsv_content ? this.detail_event.rsv_content : '');

                        }else if(type == 'live'){
                           
                           formData.append('is_live', this.detail_event.is_live);
                           formData.append('live_title', this.detail_event.live_title ? this.detail_event.live_title : '');
                           formData.append('live_content', this.detail_event.live_content ? this.detail_event.live_content : '');
                           formData.append('live_link', this.detail_event.live_link ? this.detail_event.live_link : '');
                       
                        }else if(type == 'countdown'){

                            formData.append('is_countdown', this.detail_event.is_countdown);
                            formData.append('countdown_title', this.detail_event.countdown_title ? this.detail_event.countdown_title : '');

                        }else if(type == 'location'){

                            formData.append('is_location', this.detail_event.is_location);
                            formData.append('location_title', this.detail_event.location_title ? this.detail_event.location_title : '');
                            formData.append('location', this.detail_event.location ? this.detail_event.location : '');
                            formData.append('google_maps_link', this.detail_event.google_maps_link ? this.detail_event.google_maps_link : '');
                            formData.append('google_maps', this.detail_event.google_maps ? this.detail_event.google_maps : '');

                        }else if(type == 'video'){

                            formData.append('is_video', this.detail_event.is_video);
                            formData.append('video_title', this.detail_event.video_title ? this.detail_event.video_title : '');
                            formData.append('video', this.detail_event.video ? this.detail_event.video : '');

                        }else if(type == 'gallery'){

                            formData.append('is_gallery', this.detail_event.is_gallery);
                            formData.append('gallery_style', this.detail_event.gallery_style);
                            formData.append('gallery_title', this.detail_event.gallery_title ? this.detail_event.gallery_title : '');
                            formData.append('gallery_content', this.detail_event.gallery_content ? this.detail_event.gallery_content : '');

                            formData.append('is_album', this.detail_event.is_album);
                            formData.append('gallery_show', this.detail_event.gallery_show);
                            formData.append('album_opening_bg_image_file', this.album_opening_bg_image);
                            formData.append('album_opening_bg_image', this.detail_event.album_opening_bg_image ? this.detail_event.album_opening_bg_image : '');
                            formData.append('album_title', this.detail_event.album_title);
                            formData.append('album_title_bottom', this.detail_event.album_title_bottom);
                            formData.append('album_op_title', this.detail_event.album_op_title);
                            formData.append('album_op_desc', this.detail_event.album_op_desc);
                            
                        }else if(type == 'quto'){

                            formData.append('is_quto', this.detail_event.is_quto);
                            formData.append('quto_title', this.detail_event.quto_title ? this.detail_event.quto_title : '');
                            formData.append('quto_content', this.detail_event.quto_content ? this.detail_event.quto_content : '');

                        }else if(type == 'comment'){

                            formData.append('is_comment', this.detail_event.is_comment);
                            formData.append('is_comment_sts', this.detail_event.is_comment_sts);
                            formData.append('comment_title', this.detail_event.comment_title ? this.detail_event.comment_title : '');

                        }else if(type == 'gift'){

                            formData.append('is_gift_comment', this.detail_event.is_gift_comment);
                            formData.append('is_gift', this.detail_event.is_gift);
                            formData.append('is_confirm_gift', this.detail_event.is_confirm_gift);
                            formData.append('gift_title', this.detail_event.gift_title ? this.detail_event.gift_title : '');
                            formData.append('gift_content', this.detail_event.gift_content ? this.detail_event.gift_content : '');
                            formData.append('confirm_gift_title', this.detail_event.confirm_gift_title ? this.detail_event.confirm_gift_title : '');
                            formData.append('gift_confirm_content', this.detail_event.gift_confirm_content ? this.detail_event.gift_confirm_content : '');
                         
                        }else if(type == 'info'){
                            
                            formData.append('is_info', this.detail_event.is_info);
                            formData.append('info_title', this.detail_event.info_title ? this.detail_event.info_title : '');
                            formData.append('info_content', this.detail_event.info_content ? this.detail_event.info_content : '');

                        }else if(type == 'footer'){
                        
                            formData.append('is_footer', this.detail_event.is_footer);
                            formData.append('copyright_type', this.detail_event.copyright_type);
                            formData.append('copyright_text', this.detail_event.copyright_text ? this.detail_event.copyright_text : '');
                            formData.append('copyright_sosmed', this.detail_event.copyright_sosmed ? this.detail_event.copyright_sosmed : '');
                            formData.append('copyright_photo_file', this.photo_copyright);
                            formData.append('copyright_photo', this.detail_event.copyright_image ? this.detail_event.copyright_image : '');
                        
                        }else if(type == 'navigation'){
                            
                            formData.append('is_menu', this.detail_event.is_menu);
                            formData.append('menu_style', this.detail_event.menu_style);
                            formData.append('navigation', JSON.stringify(this.detail_event.navigation));
                            
                            for(let i=0; i<this.detail_event.navigation.length;i++){
                                var file = new File([""], "null");
                                if(this.detail_event.navigation[i].icon_file){
                                    file =  this.detail_event.navigation[i].icon_file
                                }
                                formData.append('navigationfile[]', file);
                            }
                        }
                        formData.append("type", type);
                        formData.append("_method", "put");

                        this.updateBasicSetup(formData).then(() => {
                            this.loading = false
                            this.photo_file = ''
                            this.detailEvents(this.$route.params.id)
                            this.$toast.success('Successfully Update Event')
                        }).catch((error) => {
                            console.log(error)
                            this.loading = false
                            this.$toast.warning('Sorry, Something Error')
                        })

                    }
                });
            },
        }
    }

</script>

<style scoped>
    .btn-image-remove{
        padding: 0px 15px;
    }
</style>